module.exports = __webpack_public_path__ + "img/icons_header_logout.0694ac5a.svg";